const en = {
	accessThePrinter: 'access the printer',
	access: 'access',
	disconnect: 'disconnect',
	domainName: 'domain name',
	accessedList: 'accessed list',
	operate: 'operate',
	edit: 'edit',
	introduction: 'introduction',
	modifyInformation: 'modify information',
	sure: 'sure',
	cancel: 'cancel',
	name: 'name',
	connected: 'connected',
	disconnected: 'disconnected',
	splitServerIinfo: 'split server information',
};

export default en;
